"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SynchronizedStore = void 0;
class SynchronizedStore {
    constructor(store, informant) {
        this.store = store;
        this.informant = informant;
    }
    setItem(key, value) {
        this.store.setItem(key, value);
        this.informant.setItem(key, value);
    }
    getItem(key) {
        return this.store.getItem(key);
    }
    removeItem(key) {
        this.store.removeItem(key);
        this.informant.removeItem(key);
    }
    clear() {
        this.store.clear();
        this.informant.clear();
    }
}
exports.SynchronizedStore = SynchronizedStore;
//# sourceMappingURL=synchronizedStore.js.map